import { IResponseCyclesCode } from 'v2/resources/types/cycles';

export interface IStatusCyclesCode {
  cyclesCode: Array<IResponseCyclesCode>;
}
export const initialState: IStatusCyclesCode = {
  cyclesCode: [],
};
